



















import type { PropType } from '@vue/composition-api';
import { defineComponent } from '@vue/composition-api';
import { ButtonType, ParagraphSize } from '@getaccept/lib-ui';
import { t } from '@getaccept/lib-shared/src/helpers/translation.helper';
import { AvatarHelper } from '@getaccept/lib-shared/src/helpers/avatars.helper';
import type { User } from '@getaccept/lib-shared/src/users/types/user';
import { DrView } from '@getaccept/dsr-shared';

export default defineComponent({
  name: 'OwnerContact',
  props: {
    user: {
      type: Object as PropType<User>,
      default: null,
    },
  },
  setup() {
    const ownerMessage =
      'Welcome to this digital sales room! I’m the creator and owner of this room, let me know if you have any questions!';

    return {
      ownerMessage,
      t,
      displayName: AvatarHelper.getDisplayName,
      ButtonType,
      ParagraphSize,
      DrView,
    };
  },
});
